import { createContext, FC, ReactNode, useContext, useEffect, useState } from "react";
import { useAuth, UserPropertyName } from "contexts/AuthProvider";

export type UserCountryContextType = {
  loading: boolean;
  country: string;
  region: string;
  locale: string;
  setUrlParameters: (urlParams: any) => void;
};

const UserCountryContextDefaultState: UserCountryContextType = {
  loading: false,
  country: "",
  region: "",
  locale: "",
  setUrlParameters: (urlParams: any) => { },
};

export const UserCountryContext = createContext(UserCountryContextDefaultState);

interface UserCountryProviderProps {
  children: ReactNode;
}

const UserCountryProvider: FC<UserCountryProviderProps> = ({ children }) => {
  const { authenticating, isAuthenticated, getUserProperty } = useAuth();
  const [region, setRegion] = useState('');
  const [country, setCountry] = useState('');
  const [locale, setLocale] = useState('');
  const [loading, setLoading] = useState(false);
  const [urlParams, setUrlParams] = useState(null as any);

  const setUrlParameters = (urlParams: any) => {
    setUrlParams(urlParams);
    console.log("[UserCountryProvider] Set url parameters");
    console.log(urlParams);
    setLocale((urlParams as any).locale);
    setRegion((urlParams as any).region);
    setCountry((urlParams as any).country);
  };

  const getRegionFromCountry = (country: string) => {
    //Hard code below logic for time being. We will figure this our later.
    if(["UK","DE","FR","ES","BE","NL","CZ","PL","SK","PT"].some(i => i === country.toUpperCase())) return 'emea';
    if(["US","CA","BR","CL"].some(i => i === country.toUpperCase())) return 'amer';
    if(["CN","HK","TW","KR"].some(i => i === country.toUpperCase())) return 'asia';
    return '';
  };

  useEffect(() => {
    async function getUserInfo() {
      if (!authenticating && isAuthenticated()) {
        setLoading(true);
        const country = getUserProperty(UserPropertyName.COUNTRY_CODE);
        setCountry(country);
        setLocale(getUserProperty(UserPropertyName.LANGUAGE_CODE));
        setRegion(getRegionFromCountry(country));
        setLoading(false);
        console.log(`[UserCountryProvider] set user's country: ${getUserProperty(UserPropertyName.COUNTRY_CODE)}, language: ${getUserProperty(UserPropertyName.LANGUAGE_CODE)}`);
      }
    };
    getUserInfo();
  }, [authenticating]);

  return <UserCountryContext.Provider value={{ loading, region, country, locale, setUrlParameters }}>
    {children}
  </UserCountryContext.Provider>
};

export default UserCountryProvider;
export const useUserCountry = () => useContext(UserCountryContext);